// frontend/src/components/cashier/FinishedRaceBoard.js
import moment from 'moment-timezone';
import { api } from '../../services/api.js';
import { VENEZUELA_TIMEZONE } from '../../utils/cashierUtils.js';

export const loadAndRenderFinishedRace = async (race, state, appState) => {
    const container = document.getElementById('center-dynamic-area');
    if (!container) return;

    const startOfDay = moment().tz(VENEZUELA_TIMEZONE).startOf('day').utc().toISOString();
    const endOfDay = moment().tz(VENEZUELA_TIMEZONE).endOf('day').utc().toISOString();
    const url = `/races/results?status=finished&track_id=${race.track_id}&start_time_after=${startOfDay}&end_time_before=${endOfDay}`;

    try {
        const response = await api.get(url);
        const racesWithResults = response.races || response || [];
        const raceData = racesWithResults.find(r => r.id === race.id) || race;

        let firstPlace = raceData.results?.find(r => r.position === 1);
        let secondPlace = raceData.results?.find(r => r.position === 2);
        let thirdPlace = raceData.results?.find(r => r.position === 3);

        if (!firstPlace && raceData.first_place_horse_id) {
            const h1 = state.currentHorses?.find(h => h.id == raceData.first_place_horse_id);
            if (h1) firstPlace = { horse_number: h1.horse_number, horse_name: h1.name };
            const h2 = state.currentHorses?.find(h => h.id == raceData.second_place_horse_id);
            if (h2) secondPlace = { horse_number: h2.horse_number, horse_name: h2.name };
            const h3 = state.currentHorses?.find(h => h.id == raceData.third_place_horse_id);
            if (h3) thirdPlace = { horse_number: h3.horse_number, horse_name: h3.name };
        }

        const trackNameNormalized = (state.selectedTrack?.name || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        // Soporte agregado para Valencia
        const isNational = trackNameNormalized.includes('rinconada') || trackNameNormalized.includes('valencia');
        const exchangeRate = appState.exchangeRate || 0;

        const formatVal = (val) => {
            if (val === undefined || val === null) return '<span style="color:#64748b;">-</span>';
            let n = parseFloat(val);
            if (isNaN(n) || n <= 0) return '<span style="color:#64748b;">-</span>';
            
            // ⭐ FIX POKA-YOKE: Visualización y Retrocompatibilidad
            if (isNational) {
                // Si el monto de la BD es muy pequeño (ej. 6.83) significa que es un ticket VIEJO de 
                // la semana pasada (guardado en dólares). Lo multiplicamos para no romper el historial.
                // Si el monto es mayor a 20 (ej. 250), es de la arquitectura nueva y se imprime puro.
                if (n < 20 && exchangeRate > 20) {
                    n = n * exchangeRate;
                }
                return `Bs ${n.toFixed(2)}`;
            }
            
            // Si es Internacional (Gringo), siempre se muestra en Dólares.
            return `$${n.toFixed(2)}`;
        };

        const win1 = formatVal(raceData.win_payoff || raceData.win_payoff_1);
        const place1 = formatVal(raceData.place_payoff || raceData.place_payoff_1);
        const show1 = formatVal(raceData.show_payoff || raceData.show_payoff_1); 
        const place2 = formatVal(raceData.place_payoff_2 || raceData.place_payoff2);
        const show2 = formatVal(raceData.show_payoff_2 || raceData.show_payoff2);
        const show3 = formatVal(raceData.show_payoff_3 || raceData.show_payoff3 || raceData.trifecta_payoff);

        container.innerHTML = `
            <div style="background:#14532d; border:2px solid #D4AF37; border-radius:8px; padding:15px; box-shadow: 0 4px 6px rgba(0,0,0,0.3); width: 100%;">
                <div style="display:flex; justify-content:center; align-items:center; border-bottom:2px solid #D4AF37; padding-bottom:10px; margin-bottom:15px;">
                    <h4 style="color:#D4AF37; font-weight:900; font-size:1.5rem; margin:0; text-transform:uppercase;">
                        <i class="fas fa-trophy"></i> RESULTADOS OFICIALES
                    </h4>
                </div>

                <table style="width:100%; border-collapse:collapse; text-align:center; color:white;">
                    <thead>
                        <tr style="background:#064e3b; color:#D4AF37; font-size:1rem; text-transform:uppercase;">
                            <th style="padding:10px; border-bottom:2px solid #D4AF37;">Lugar</th>
                            <th style="padding:10px; border-bottom:2px solid #D4AF37; text-align:left;">Ejemplar</th>
                            <th style="padding:10px; border-bottom:2px solid #D4AF37;">Win</th>
                            <th style="padding:10px; border-bottom:2px solid #D4AF37;">Place</th>
                            <th style="padding:10px; border-bottom:2px solid #D4AF37;">Show</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="background:rgba(255,255,255,0.05);">
                            <td style="padding:12px; border-bottom:1px solid #334155; font-size:1.5rem; font-weight:900; color:#FCD34D;">1°</td>
                            <td style="padding:12px; border-bottom:1px solid #334155; font-weight:bold; text-align:left;">${firstPlace ? `#${firstPlace.horse_number} ${firstPlace.horse_name}` : 'N/A'}</td>
                            <td style="padding:12px; border-bottom:1px solid #334155; color:#4ade80; font-family:monospace; font-size:1.1rem; font-weight:bold;">${win1}</td>
                            <td style="padding:12px; border-bottom:1px solid #334155; color:#60a5fa; font-family:monospace; font-size:1.1rem; font-weight:bold;">${place1}</td>
                            <td style="padding:12px; border-bottom:1px solid #334155; color:#cbd5e1; font-family:monospace; font-size:1.1rem; font-weight:bold;">${show1}</td>
                        </tr>
                        <tr>
                            <td style="padding:12px; border-bottom:1px solid #334155; font-size:1.5rem; font-weight:900; color:#e2e8f0;">2°</td>
                            <td style="padding:12px; border-bottom:1px solid #334155; font-weight:bold; text-align:left;">${secondPlace ? `#${secondPlace.horse_number} ${secondPlace.horse_name}` : 'N/A'}</td>
                            <td style="padding:12px; border-bottom:1px solid #334155; color:#64748b;">-</td>
                            <td style="padding:12px; border-bottom:1px solid #334155; color:#60a5fa; font-family:monospace; font-size:1.1rem; font-weight:bold;">${place2}</td>
                            <td style="padding:12px; border-bottom:1px solid #334155; color:#cbd5e1; font-family:monospace; font-size:1.1rem; font-weight:bold;">${show2}</td>
                        </tr>
                        <tr style="background:rgba(255,255,255,0.05);">
                            <td style="padding:12px; border-bottom:none; font-size:1.5rem; font-weight:900; color:#b45309;">3°</td>
                            <td style="padding:12px; border-bottom:none; font-weight:bold; text-align:left;">${thirdPlace ? `#${thirdPlace.horse_number} ${thirdPlace.horse_name}` : 'N/A'}</td>
                            <td style="padding:12px; border-bottom:none; color:#64748b;">-</td>
                            <td style="padding:12px; border-bottom:none; color:#64748b;">-</td>
                            <td style="padding:12px; border-bottom:none; color:#cbd5e1; font-family:monospace; font-size:1.1rem; font-weight:bold;">${show3}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        `;
    } catch (err) {
        container.innerHTML = `<div class="text-center text-red-400 py-4 font-bold" style="margin-top:50px;">Error al cargar los resultados.</div>`;
    }
};